import { z } from "zod";
import { utcDatetime } from "@common/helpers/date";

/** A task in the work item where the caller has unread chat messages. */
export const CloseUnreadTaskSchema = z.object({
    taskId: z.string().uuid(),
    title: z.string(),
    unreadCount: z.number().int().positive(),
    lastUnreadAt: utcDatetime,
});

export type CloseUnreadTask = z.infer<typeof CloseUnreadTaskSchema>;

export const CloseUnreadTasksResponseSchema = z.object({
    tasks: z.array(CloseUnreadTaskSchema),
});

export type CloseUnreadTasksResponse = z.infer<
    typeof CloseUnreadTasksResponseSchema
>;
